module.exports = __webpack_public_path__ + "img/logo-white.ecd21c22.svg";